import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import HeroComp from "../../components/home/hero/HeroComp";
import HeroSkeleton from "../..//components/loader/HeroSkeleton";

const HeroCTR = () => {
  const [heroData, setHeroData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  // 🔹 Fetch packages and take first 3
  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const res = await fetch("https://bonvoytourism.com/bonvoytourismbackend/api/packages");
        // const res = await fetch("https://demo.bonvoytourism.com/bonvoytourismbackend/api/packages");
        // const res = await fetch("http://localhost:3000/bonvoytourismbackend/api/packages");
        const data = await res.json();

        if (data.packages?.length) {
          const formatted = data.packages.slice(0, 3).map((pkg) => ({
            bg: pkg.img,
            heading: pkg.title,
            para: pkg.duration || "Explore this tours",
            link: `/tour/${pkg.slug}`,
            // link: `/tour/${pkg.id}`,
          }));

          setHeroData(formatted);
        }
      } catch (error) {
        console.error("Hero packages fetch error:", error);
      }
    };

    fetchPackages();
  }, []);

  // 🔹 Auto slide
  useEffect(() => {
    if (isHovered || heroData.length === 0) return;

    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % heroData.length);
    }, 8000);

    return () => clearInterval(interval);
  }, [isHovered, heroData.length]);

  // if (!heroData.length) return null;
  if (!heroData.length) {
    return <HeroSkeleton />;
  }


  return (
    <div
      className="relative h-screen overflow-hidden"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <AnimatePresence initial={false}>
        <motion.div
          key={currentIndex}
          className="absolute inset-0 w-full h-full"
          initial={{ opacity: 0.5 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0.5 }}
          transition={{ duration: 1, ease: "easeInOut" }}
        >
          <HeroComp
            bg={heroData[currentIndex].bg}
            heading={heroData[currentIndex].heading}
            // para={heroData[currentIndex].para}
            link={heroData[currentIndex].link}
          />
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default HeroCTR;
